/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaGamepad, FaTrophy, FaUsers, FaBook, FaGraduationCap, FaPaintBrush, FaPlay } from 'react-icons/fa';
import { GiBrain, GiTeacher, GiSoccerBall, GiStarsStack } from 'react-icons/gi';
import { IoMdSchool } from 'react-icons/io';

const KidsGamification = () => {
    const [activeFeature, setActiveFeature] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);

    const features = [
        {
            title: "Learning Adventures",
            icon: <FaBook className="text-4xl" />,
            description: "Interactive story-based lessons where kids become heroes of knowledge",
            color: "bg-purple-600",
            examples: ["Math quests", "Science expeditions", "Reading challenges"]
        },
        {
            title: "Skill Builders",
            icon: <GiBrain className="text-4xl" />,
            description: "Mini-games that develop cognitive skills through play",
            color: "bg-blue-600",
            examples: ["Memory puzzles", "Logic games", "Pattern recognition"]
        },
        {
            title: "Creative Play",
            icon: <FaPaintBrush className="text-4xl" />,
            description: "Art and creativity tools with educational objectives",
            color: "bg-pink-600",
            examples: ["Story creators", "Music makers", "Digital coloring"]
        },
        {
            title: "Active Learning",
            icon: <GiSoccerBall className="text-4xl" />,
            description: "Physical activities integrated with educational content",
            color: "bg-green-600",
            examples: ["Math hopscotch", "Spelling relays", "Science scavenger hunts"]
        }
    ];

    const ageGroups = [
        {
            range: "3-5 years",
            focus: "Basic concepts & motor skills",
            activities: ["Shape sorting", "Color matching", "Simple counting"]
        },
        {
            range: "6-8 years",
            focus: "Foundational academics",
            activities: ["Reading games", "Basic math", "Simple science"]
        },
        {
            range: "9-12 years",
            focus: "Skill development",
            activities: ["Problem solving", "Creative writing", "STEM challenges"]
        }
    ];

    const togglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-900  to-gray-900 overflow-hidden">


            <div className="max-w-6xl mx-auto relative z-10">
                {/* Header with Animated Elements */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="text-center mb-16 relative"
                >
                    <div className="absolute -top-8 -left-8 w-20 h-20 bg-purple-600 rounded-full opacity-20 blur-xl" />
                    <div className="absolute -bottom-8 -right-8 w-24 h-24 bg-blue-600 rounded-full opacity-20 blur-xl" />

                    <motion.h2
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2 }}
                        className="text-4xl sm:text-5xl font-bold mb-6 relative z-10"
                    >
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
                            Learning Through Play
                        </span>
                    </motion.h2>

                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="inline-block px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6"
                    >
                        <p className="text-white text-lg font-medium">
                            Transforming education into exciting adventures for kids aged 3-12
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6 }}
                        className="flex justify-center space-x-4 mt-8"
                    >
                        <div className="h-1 w-8 bg-purple-500 rounded-full" />
                        <div className="h-1 w-8 bg-blue-500 rounded-full" />
                        <div className="h-1 w-8 bg-pink-500 rounded-full" />
                    </motion.div>
                </motion.div>

                {/* Video Demonstration Section */}
                <div className="mb-16">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                        className="max-w-5xl mx-auto"
                    >
                        <div className="relative rounded-2xl overflow-hidden border-4 border-gray-800 shadow-2xl">
                            <div className="relative aspect-w-16 aspect-h-9">
                                <video
                                    ref={videoRef}
                                    className="w-full h-full object-cover"
                                    controls
                                    muted
                                    autoPlay
                                    loop

                                >
                                    <source src="heroVideo.mp4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>

                                {/* {!isPlaying && (
                                    <button
                                        onClick={togglePlay}
                                        className="absolute inset-0 flex items-center justify-center w-full h-full bg-black bg-opacity-40 transition-all hover:bg-opacity-20"
                                    >
                                        <motion.div
                                            animate={{ scale: [1, 1.1, 1] }}
                                            transition={{ duration: 1.5, repeat: Infinity }}
                                            className="w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center shadow-lg"
                                        >
                                            <FaPlay className="text-white text-2xl ml-1" />
                                        </motion.div>
                                    </button>
                                )} */}
                            </div>

                            {/* <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
                                <h4 className="text-xl font-bold text-white">Experience Our Gamified Learning Platform</h4>
                                <p className="text-gray-300 mt-1">
                                    See how children engage with our interactive educational games
                                </p>
                            </div> */}
                        </div>
                    </motion.div>
                </div>

                {/* Interactive Features Showcase */}
                <div className="mb-16">
                    <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-2xl font-bold text-center mb-10 text-white"
                    >
                        <span className="relative inline-block">
                            Our Gamification Features
                            <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full" />
                        </span>
                    </motion.h3>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                        {features.map((feature, index) => (
                            <motion.button
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                                viewport={{ once: true }}
                                whileHover={{ scale: 1.05, y: -5 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => setActiveFeature(index)}
                                className={`p-4 rounded-xl ${activeFeature === index ? `${feature.color} text-white shadow-xl` : 'bg-gray-800 text-gray-200 shadow-lg hover:bg-gray-700'}`}
                            >
                                <div className="flex flex-col items-center">
                                    <div className="mb-3">{feature.icon}</div>
                                    <span className="font-medium text-sm sm:text-base">{feature.title}</span>
                                </div>
                            </motion.button>
                        ))}
                    </div>

                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeFeature}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                            className={`rounded-2xl p-6 shadow-2xl border-l-4 ${features[activeFeature].color} border bg-gray-800`}
                        >
                            <div className="flex flex-col md:flex-row gap-6">
                                <div className="md:w-1/3 flex justify-center">
                                    <div className={`p-6 rounded-full ${features[activeFeature].color} bg-opacity-20 text-center`}>
                                        {features[activeFeature].icon}
                                    </div>
                                </div>
                                <div className="md:w-2/3">
                                    <h4 className="text-2xl font-bold mb-3 text-white">{features[activeFeature].title}</h4>
                                    <p className="text-white mb-4">{features[activeFeature].description}</p>
                                    <div className="flex flex-wrap gap-2">
                                        {features[activeFeature].examples.map((example, i) => (
                                            <motion.span
                                                key={i}
                                                initial={{ opacity: 0, scale: 0.9 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{ delay: i * 0.1 }}
                                                className="bg-gray-700 text-gray-200 px-3 py-1 rounded-full text-sm"
                                            >
                                                {example}
                                            </motion.span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>

                {/* Age-Specific Learning */}
                <div className="mb-16">
                    <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-2xl font-bold text-center mb-10 text-white"
                    >
                        <span className="relative inline-block">
                            Designed for Different Age Groups
                            <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full" />
                        </span>
                    </motion.h3>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {ageGroups.map((group, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                                viewport={{ once: true }}
                                whileHover={{ y: -10 }}
                                className="bg-gray-800 rounded-xl overflow-hidden shadow-xl"
                            >
                                <div className={`h-3 ${index === 0 ? 'bg-blue-500' : index === 1 ? 'bg-purple-500' : 'bg-green-500'}`} />
                                <div className="p-6">
                                    <div className="flex items-center gap-3 mb-4">
                                        <IoMdSchool className={`text-3xl ${index === 0 ? 'text-blue-400' : index === 1 ? 'text-purple-400' : 'text-green-400'}`} />
                                        <h4 className="text-xl font-bold text-white">{group.range}</h4>
                                    </div>
                                    <p className="text-gray-300 mb-4">{group.focus}</p>
                                    <ul className="space-y-2">
                                        {group.activities.map((activity, i) => (
                                            <motion.li
                                                key={i}
                                                initial={{ opacity: 0, x: -10 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ delay: i * 0.1 }}
                                                className="flex items-start gap-2"
                                            >
                                                <span className={`mt-1 ${index === 0 ? 'text-blue-400' : index === 1 ? 'text-purple-400' : 'text-green-400'}`}>•</span>
                                                <span className="text-gray-300">{activity}</span>
                                            </motion.li>
                                        ))}
                                    </ul>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Benefits Section */}
                <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 shadow-2xl mb-16 border border-gray-700">
                    <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-2xl font-bold text-center mb-10 text-white"
                    >
                        <span className="relative inline-block">
                            Why Gamification Works for Kids
                            <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 to-red-500 rounded-full" />
                        </span>
                    </motion.h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            {
                                title: "Increased Engagement",
                                icon: <FaGamepad className="text-3xl text-purple-500" />,
                                description: "Kids stay focused 3x longer compared to traditional methods"
                            },
                            {
                                title: "Better Retention",
                                icon: <GiBrain className="text-3xl text-blue-500" />,
                                description: "Play-based learning improves memory by 45%"
                            },
                            {
                                title: "Confidence Building",
                                icon: <FaTrophy className="text-3xl text-yellow-500" />,
                                description: "Reward systems motivate continuous learning"
                            },
                            {
                                title: "Social Learning",
                                icon: <FaUsers className="text-3xl text-green-500" />,
                                description: "Collaborative games teach teamwork skills"
                            }
                        ].map((benefit, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ delay: index * 0.1 }}
                                viewport={{ once: true }}
                                whileHover={{ scale: 1.03, y: -5 }}
                                className="bg-gray-800 rounded-xl p-6 text-center border border-gray-700"
                            >
                                <div className="mb-4">{benefit.icon}</div>
                                <h4 className="text-lg font-bold mb-2 text-white">{benefit.title}</h4>
                                <p className="text-gray-300">{benefit.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* CTA */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                    className="text-center"
                >
                    <a href="/quickenquiry">
                        <motion.button
                            whileHover={{
                                scale: 1.05,
                                background: "linear-gradient(to right, #8b5cf6, #3b82f6, #ec4899)"
                            }}
                            whileTap={{ scale: 0.95 }}
                            className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-500 text-white font-bold rounded-full shadow-xl hover:shadow-2xl transition-all inline-flex items-center relative overflow-hidden"
                        >
                            <span className="relative z-10">Explore Kids Learning Games</span>
                            <FaGraduationCap className="ml-2 relative z-10" />

                            {/* Animated background */}
                            <motion.div
                                className="absolute inset-0 bg-gradient-to-r from-purple-500 to-blue-400 opacity-0"
                                animate={{
                                    opacity: [0, 0.5, 0],
                                    x: ["-100%", "100%"]
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    delay: 0.5
                                }}
                            />
                        </motion.button>
                    </a>
                    <p className="mt-4 text-gray-400">
                        Perfect for schools, homeschoolers, and parents
                    </p>
                </motion.div>
            </div>
        </section>
    );
};

export default KidsGamification;